import { motion } from "framer-motion";
import styles from "../styles/index";
import { staggerContainer } from "../utils/motion";
import { useTranslation } from "react-i18next";
import { TitleText, TypingText } from "../components/customText";
import { handCrafts } from "../constants";
import HandCraftCard from "../components/handCraftCard";
const HandCraft = () => {
  const { t } = useTranslation();
  return (
    <section className={`${styles.paddings}`}>
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
        className={`${styles.innerWidth} mx-auto flex flex-col`}
      >
        <TypingText title={t("homeMade")} textStyles="text-center" />
        <TitleText title={t("homeMadeTitle")} textStyles="text-center" />
        <div className="mt-[50px] flex flex-col gap-[30px]">
          {handCrafts.map((handCraft, index) => (
            <HandCraftCard {...handCraft} index={index + 1} key={index} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default HandCraft;
